import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHashHistory } from "vue-router";
import SeamlessVideoPage from "@/../../shared/components/SeamlessVideoPageComponent.vue";
import main from './videoBatches/main.json';
import data_matrix from './videoBatches/data_matrix.json';
import pick from './videoBatches/pick.json';
import product from './videoBatches/product.json';
import unloading from './videoBatches/unloading.json';
import water from './videoBatches/water.json';
import ret from './videoBatches/return.json';

const routes = [
  {
    path: "/",
    name: "",
    component: SeamlessVideoPage,
    screensaver: false,
    props: {
      title: "",
      homeButtonIcon: "images/house_icon.png",
      backButtonIcon: "images/back_icon.png",
      uiToogleButtonIcon: "images/eye_icon.png",
      hotspotIcon: "images/hotspot.gif",
      fadeTime: 0.35, // seconds
      fontFamily: "Montserrat",
      videoBatches: [
      ],
    },
  }
];

routes[0].props.videoBatches.push(...main);
routes[0].props.videoBatches.push(...data_matrix);
routes[0].props.videoBatches.push(...product);
routes[0].props.videoBatches.push(...ret);
routes[0].props.videoBatches.push(...pick);
routes[0].props.videoBatches.push(...water);
routes[0].props.videoBatches.push(...unloading);

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

const app = createApp(App);
app.use(router);
app.mount("#app");
